var map = {
	"./en.json": [
		7960,
		960
	],
	"./ja.json": [
		5521,
		521
	],
	"./ko.json": [
		8623,
		623
	],
	"./zh_CN.json": [
		117,
		117
	],
	"./zh_TW.json": [
		4312,
		312
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6887;
module.exports = webpackAsyncContext;